import React, { useState } from 'react';
import { Breadcrumb, Row, Col, Space, Input, Dropdown, Menu, Button } from 'antd';

import { useNavigate } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
const FeedbackSearch = (props) => {
    const navigate = useNavigate();
    const level1Items = ['iHealth App & Services', 'Ease (BP3L)', 'Feel (BP5)', 'Neo (BP5S)', 'Sense (BP7)', 'View (BP7S)'
        , 'Clear (BPM1)', 'Track (KN-550BT)', 'Push (KD-723)', 'KD-926', 'Lina (HS2)'
        , 'Fit/Nexus (HS2S)', 'Lite (HS4/HS4S)', 'Core (HS6)', 'Neuxs Pro (HS2S Pro)', 'Align (BG1)', 'Smart (BG5)'
        , 'Gluco+ (BG5S)', 'Livocare (PO1)', 'Air (PO3/PO3M)', 'PT3SBT', 'TS28B',
        'Edge (AM3S)', 'Wave (AM4)', 'Vital (AM5)',]
    const level1KeyItems = ['iHealth App & Services', 'BP3L', 'BP5', 'BP5S', 'BP7', 'BP7S'
        , 'BPM1', 'KN550BT,550BT,550bt,KN-550BT', 'KD-723', 'KD-926', 'HS2'
        , 'HS2S', 'HS4/HS4S', 'HS6', 'HS2S Pro', 'BG1', 'BG5'
        , 'BG5S', 'PO1', 'PO3/PO3M', 'PT3SBT', 'TS28B',
        'AM3S', 'AM4', 'AM5']
    const level2DeviceItems = ['Setup Issues', 'Connectivity Issues', 'Measurement Accuracy Issues', 'Device Performance',
        'Battery Performance', 'Other']
    const level2DeviceKeyItems = ['Setup Issues', 'Connectivity Issues', 'Measurement Accuracy Issues', 'Device Performance',
        'Battery Performance', 'Other']
    const level2AppItems = ['Log In/Create a new account', 'Summary', 'Account', 'Share', 'Found a Bug', 'Add Device Issues', 'Other']
    const level2AppKeyItems = ['Log In/Create a new account', 'Summary', 'Account', 'Share', 'Found a Bug', 'Add Device Issues', 'Other']
    const deviceTypeItems = ['Blood Pressure Monitors', 'Scales', 'Blood Glucose Meter', 'Pulse Oximeter', 'Thermometer', 'Activity Trackers', 'Platform']
    const channelItems = ['platform', 'plugin']
    const appIdItems = ['com.ihealthlabs.MyVitalsPro', 'com.ihealthlabs.Debug']
    const customerSourceItemsName = ['ToB Customer', 'ToC Customer']
    const customerSourceItems = ['2B', '2C']
    //下啦列表数据
    const [customerSourceItem, setCustomerSourceItem] = useState([{}])
    const [itemsLevel1, setItemsLevel1] = useState([{}])
    const [itemsLevel2, setItemsLevel2] = useState([{}])
    const [itemsDeviceType, setItemsDeviceType] = useState([{}])
    const [itemsAppId, setItemsAppId] = useState([{}])
    const [itemsChannel, setItemsChannel] = useState([{}])

    //level1选中后允许选择level2
    const [level2IsDisabled, setLevel2IsDisabled] = useState(true)
    //下拉框显示数据
    const [customerSourceName, setCustomerSourceName] = useState("Please Select")
    const [selectLevel1, setselectLevel1] = useState("Please Select")
    const [selectLevel2, setselectLevel2] = useState("Please Select")
    const [selectDeviceType, setselectDeviceType] = useState("Please Select")
    const [selectAppID, setselectAppID] = useState("Please Select")
    const [selectChannel, setselectChannel] = useState("Please Select")

    //接口请求数据
    const [ticketId, setTicketId] = useState(null)
    const [page, setPage] = useState(1)
    const [deviceModel, setDeviceModel] = useState('')
    const [customerSource, setCustomerSource] = useState('')
    const [level1, setLevel1] = useState('')
    const [level2, setLevel2] = useState('')
    const [appVersion, setAppVersion] = useState('')
    const [phoneOS, setPhoneOS] = useState('')
    const [deviceType, setDeviceType] = useState('')
    const [fv, setFV] = useState('')
    const [hv, setHV] = useState('')
    const [phoneDevice, setPhoneDevice] = useState('')
    const [mac, setMac] = useState('')
    const [appId, setAppId] = useState('')
    const [channel, setChannel] = useState('')

    React.useEffect(() => {
        if (props != null && props.history != null) {
            console.log('search:', props.history)
            history(props.history.data)
        }
        setItemCustomerSourceName()
        setItemLevel1Name()

        setItemDeviceTypeName()
        setItemAppIdName()
        setItemChannel()

    }, [])

    function setItemCustomerSourceName() {
        var list = [{}]
        customerSourceItemsName.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setCustomerSourceItem(list)
    }
    function setItemLevel1Name() {
        var list = [{}]
        level1Items.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setItemsLevel1(list)
    }
    function setItemLevel2Name(level2Items) {
        var list = [{}]
        level2Items.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setItemsLevel2(list)
    }
    function setItemDeviceTypeName() {
        var list = [{}]
        deviceTypeItems.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setItemsDeviceType(list)
    }
    function setItemAppIdName() {
        var list = [{}]
        appIdItems.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setItemsAppId(list)
    }
    function setItemChannel() {
        var list = [{}]
        channelItems.map((item, index) => {
            list[index] = { key: index, label: item }
        })
        setItemsChannel(list)
    }

    function onStart() {
        props.setNewKey('developerCenter/feedbackList')
        navigate('/developerCenter/feedbackList')

    }
    /**
         * 展示历史数据
         * @param {*} data 历史数据
         */
    function history(data) {
        setTicketId(data.ticketId)
        setDeviceModel(data.deviceModel)
        if (data.level1 !== '') {
            setLevel1(data.level1)
            setselectLevel1(data.level1)
            setLevel2IsDisabled(false)
            if (data.level2 !== "") {
                setLevel2(data.level2)
                setselectLevel2(data.level2)
            }
        }
        if (data.customerSource === '2B') {
            setCustomerSource(data.customerSource)
            setCustomerSourceName('ToB Customer')
        } else if (data.customerSource === '2C') {
            setCustomerSource(data.customerSource)
            setCustomerSourceName('ToC Customer')
        }
        setAppVersion(data.appVersion)
        setPhoneOS(data.phoneOS)
        if (data.deviceType !== '') {
            setDeviceType(data.deviceType)
            setselectDeviceType(data.deviceType)

        }
        setFV(data.fv)
        setHV(data.hv)
        setPhoneDevice(data.phoneDevice)
        setMac(data.mac)
        if (data.appId !== '') {
            setAppId(data.appId)
            setselectAppID(data.appId)

        }
        if (data.channel !== '') {
            setChannel(data.channel)
            setselectChannel(data.channel)
        }
    }
    //搜索
    function onSearch() {
        props.onSearch({
            ticketId: ticketId,
            page: page,
            deviceModel: deviceModel,
            level1: level1,
            level2: level2,
            appVersion: appVersion,
            phoneOS: phoneOS,
            deviceType: deviceType,
            fv: fv,
            hv: hv,
            phoneDevice: phoneDevice,
            mac: mac,
            appId: appId,
            channel: channel,
            customerSource: customerSource
        })
    }
    //重制
    const remake = () => {
        setCustomerSourceName("Please Select")
        setselectLevel1("Please Select")
        setselectLevel2("Please Select")
        setselectDeviceType("Please Select")
        setselectAppID("Please Select")
        setselectChannel("Please Select")

        setLevel2IsDisabled(true)
        setTicketId(null)
        setCustomerSource('')
        setDeviceModel('')
        setLevel1('')
        setLevel2('')
        setAppVersion('')
        setPhoneOS('')
        setDeviceType('')
        setFV('')
        setHV('')
        setPhoneDevice('')
        setMac('')
        setAppId('')
        setChannel('')
        setPage(1)
    }
    function onInPutTicketID(e) {
        setTicketId(e.target.value)
    }
    function onInPutDeviceModel(e) {
        setDeviceModel(e.target.value)
    }
    const itemsLevel1onClick = ({ key }) => {
        setLevel1(level1KeyItems[key])
        setselectLevel1(level1Items[key])
        if (level1Items[key] === 'iHealth App & Services') {
            setItemLevel2Name(level2AppItems)
        } else {
            setItemLevel2Name(level2DeviceItems)
        }
        setLevel2IsDisabled(false)
    };
    const itemsLevel2onClick = ({ key }) => {
        if (level1 === 'iHealth App & Services') {
            setLevel2(level2AppKeyItems[key])
            setselectLevel2(level2AppItems[key])
        } else {
            setLevel2(level2DeviceKeyItems[key])
            setselectLevel2(level2DeviceItems[key])
        }

    };

    function onInPutAppVersion(e) {
        setAppVersion(e.target.value)
    }
    function onInPutPhoneOS(e) {
        setPhoneOS(e.target.value)
    }
    const itemsDeviceTypeOnClick = ({ key }) => {
        setDeviceType(deviceTypeItems[key])
        setselectDeviceType(deviceTypeItems[key])
    };
    function onInPutFV(e) {
        setFV(e.target.value)
    }
    function onInPutHV(e) {
        setHV(e.target.value)
    }
    function onInPutPhoneDevice(e) {
        setPhoneDevice(e.target.value)
    }
    function onInPutMAC(e) {
        setMac(e.target.value)
    }
    const itemsAppIdOnClick = ({ key }) => {
        setAppId(appIdItems[key])
        setselectAppID(appIdItems[key])
    }
    const itemsChannelOnClick = ({ key }) => {
        setChannel(channelItems[key])
        setselectChannel(channelItems[key])
    }
    const itemsCustomerSourceOnClick = ({ key }) => {
        setCustomerSource(customerSourceItems[key])
        setCustomerSourceName(customerSourceItemsName[key])
    }
    return (
        <div style={{ minHeight: '441px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
            <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>Feedback</a></Breadcrumb.Item>
                <Breadcrumb.Item><a style={{ fontSize: '12px' }}>反馈列表</a></Breadcrumb.Item>
            </Breadcrumb>
            <div style={Styles.title}>搜索反馈列表</div>
            <Row style={{ marginTop: '32px' }}>
                <Col style={Styles.itemTitle}>
                    Ticket ID
                </Col>
                <Col>
                    <Input
                        value={ticketId}
                        defaultValue={ticketId}
                        placeholder="Please Enter"
                        maxLength="10"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutTicketID}
                    />
                </Col>
                <Col style={Styles.itemTitle}>
                    Device Model
                </Col>
                <Col>
                    <Input
                        value={deviceModel}
                        defaultValue={deviceModel}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutDeviceModel}
                    />
                </Col>
                <Col style={Styles.itemTitle}>
                    Customer Source
                </Col>
                <Col>
                    <Dropdown overlay={<Menu onClick={itemsCustomerSourceOnClick} items={customerSourceItem} />} style={{ width: '220px', height: '32px', }}>
                        <Button style={{ padding: '0px', width: '220px', height: '32px', color: 'rgba(0, 0, 0, 0.25)' }} >
                            <Space>
                                <div style={{ fontSize: '14px', color: customerSourceName === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '175px', height: '32px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    {customerSourceName}</div>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Col>
            </Row>
            <Row style={{ marginTop: '18px' }}>
                <Col style={Styles.itemTitle}>
                    Level1 name
                </Col>
                <Col>
                    <Dropdown overlay={<Menu onClick={itemsLevel1onClick} items={itemsLevel1} />} style={{ width: '220px', height: '32px', }}>
                        <Button style={{ padding: '0px', width: '220px', height: '32px', color: 'rgba(0, 0, 0, 0.25)' }} >
                            <Space>
                                <div style={{ fontSize: '14px', color: selectLevel1 === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '175px', height: '32px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    {selectLevel1}</div>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Col>
                <Col style={Styles.itemTitle}>
                    Level2 name
                </Col>
                <Col>
                    <Dropdown disabled={level2IsDisabled} overlay={<Menu onClick={itemsLevel2onClick} items={itemsLevel2} />} style={{ width: '220px', height: '32px', }}>
                        <Button style={{ padding: '0px', width: '220px', height: '32px', color: 'rgba(0, 0, 0, 0.25)' }}  >
                            <Space>
                                <div style={{ fontSize: '14px', color: selectLevel2 === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '175px', height: '32px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    {selectLevel2}</div>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>

                </Col>
                <Col style={Styles.itemTitle}>
                    App Version
                </Col>
                <Col>
                    <Input
                        value={appVersion}
                        defaultValue={appVersion}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutAppVersion}
                    // onPressEnter={onSearch}
                    />
                </Col>
            </Row>
            <Row style={{ marginTop: '18px' }}>

                <Col style={Styles.itemTitle}>
                    Phone OS
                </Col>
                <Col>
                    <Input
                        value={phoneOS}
                        defaultValue={phoneOS}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutPhoneOS}
                    // onPressEnter={onSearch}
                    />
                </Col>
                <Col style={Styles.itemTitle}>
                    Device type
                </Col>
                <Col >
                    <Dropdown overlay={<Menu onClick={itemsDeviceTypeOnClick} items={itemsDeviceType} />} style={{ width: '220px', height: '32px', }} >
                        <Button style={{ padding: '0px', width: '220px', height: '32px', color: 'rgba(0, 0, 0, 0.25)' }}>
                            <Space>
                                <div style={{ fontSize: '14px', color: selectDeviceType === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '175px', height: '32px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    {selectDeviceType}</div>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Col>
                <Col style={Styles.itemTitle}>
                    Firmware Version
                </Col>
                <Col >
                    <Input
                        value={fv}
                        defaultValue={fv}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutFV}
                    // onPressEnter={onSearch}
                    />
                </Col>
            </Row>
            <Row style={{ marginTop: '18px' }}>
                <Col style={Styles.itemTitle}>
                    Hardware Version
                </Col>
                <Col>
                    <Input
                        value={hv}
                        defaultValue={hv}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutHV}
                    // onPressEnter={onSearch}
                    />
                </Col>
                <Col style={Styles.itemTitle}>
                    Client Phone Device
                </Col>
                <Col>
                    <Input
                        value={phoneDevice}
                        defaultValue={phoneDevice}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutPhoneDevice}
                    // onPressEnter={onSearch}
                    />
                </Col>
                <Col style={Styles.itemTitle}>
                    MAC
                </Col>
                <Col>
                    <Input
                        value={mac}
                        defaultValue={mac}
                        placeholder="Please Enter"
                        size="large"
                        style={Styles.inputText}
                        onChange={onInPutMAC}
                    // onPressEnter={onSearch}
                    />
                </Col>
            </Row>
            <Row style={{ marginTop: '18px' }}>

                <Col style={Styles.itemTitle}>
                    App ID
                </Col>
                <Col>
                    <Dropdown overlay={<Menu onClick={itemsAppIdOnClick} items={itemsAppId} />} style={{ width: '220px', height: '32px', }} >
                        <Button style={{ padding: '0px', width: '220px', height: '32px', color: 'rgba(0, 0, 0, 0.25)' }}>
                            <Space>
                                <div style={{ fontSize: '14px', color: selectAppID === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '175px', height: '32px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    {selectAppID}</div>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Col>
                <Col style={Styles.itemTitle}>
                    Channel
                </Col>
                <Col>
                    <Dropdown overlay={<Menu onClick={itemsChannelOnClick} items={itemsChannel} />} style={{ width: '220px', height: '32px', }} >
                        <Button style={{ padding: '0px', width: '220px', height: '32px', color: 'rgba(0, 0, 0, 0.25)' }}>
                            <Space>
                                <div style={{ fontSize: '14px', color: selectChannel === "Please Select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '175px', height: '32px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    {selectChannel}</div>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Col>
            </Row>

            <Row style={{ paddingTop: '20px', paddingBottom: '30px', display: 'flex', justifyContent: 'right', marginRight: '30px' }}>
                <Col>
                    <Button onClick={remake} style={{ fontSize: '14px', width: '80px', height: '32px' }}>重置</Button>
                </Col>
                <Col>
                    <Button onClick={onSearch} style={{ fontSize: '14px', background: '#FF5300', color: 'white', width: '80px', height: '32px', marginLeft: '14px' }}>搜索</Button>
                </Col>

            </Row>
        </div>

    );

}

const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    inputText: {
        fontSize: '14px',
        width: '220px',
        borderRadius: '2px',
        height: '32px'
    },
    itemTitle: {
        width: '165px',
        height: '32px',
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        fontSize: '16px',
        paddingRight: '10px',
        paddingLeft: '0px',
        fontSize: '14px'
    },
}
export default FeedbackSearch